var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.72,
    height: 13.96,
    viewBox: "0 0 21.72 13.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-users"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.47,7.83a3.53,3.53,0,0,1,7.06,0,3.53,3.53,0,1,1-7.06,0Zm.88,0A2.65,2.65,0,1,0,12,5.18,2.68,2.68,0,0,0,9.35,7.83Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.86,17.11c0-2.1-2.21-3.87-4.86-3.87S7.14,15,7.14,17.11a.44.44,0,1,1-.88,0c0-2.65,2.65-4.75,5.74-4.75s5.74,2.21,5.74,4.75a.44.44,0,0,1-.88,0Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.06,9.27A2.68,2.68,0,0,1,5.71,6.62a2.65,2.65,0,0,1,0,5.3A2.69,2.69,0,0,1,3.06,9.27Zm.77,0a2,2,0,1,0,2-2A2,2,0,0,0,3.83,9.27Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4,17.33c0-2,2-3.64,4.31-3.64A5.52,5.52,0,0,1,7,13.91c.22,0,.33.22.22.44s-.22.33-.44.22a4.12,4.12,0,0,0-1.21-.11c-2,0-3.65,1.32-3.65,2.87a.29.29,0,0,1-.33.33C1.4,17.66,1.4,17.44,1.4,17.33Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4,11.92a2.65,2.65,0,1,1,2.65-2.65A2.62,2.62,0,0,1,18.4,11.92Zm0-4.64a2,2,0,1,0,2,2A2,2,0,0,0,18.4,7.28Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.27,17.66a.29.29,0,0,1-.33-.33c0-1.66-1.66-2.87-3.65-2.87a4.51,4.51,0,0,0-1.21.11.57.57,0,0,1-.44-.22.57.57,0,0,1,.22-.44,5.52,5.52,0,0,1,1.32-.22c2.43,0,4.31,1.65,4.31,3.64C22.6,17.55,22.38,17.66,22.27,17.66Z",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.1 -4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.1 -4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamUsers);
export default __webpack_public_path__ + "static/media/team-users.cd626ab286187920edab9779807eb0d2.svg";
export { ForwardRef as ReactComponent };